import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import SettingsPublicDetails from './scenes/SettingsPublicDetails';
import SettingsCartAbandonment from './scenes/SettingsCartAbandonment';
import SettingsCustomerPortal from './scenes/SettingsCustomerPortal';
import SettingsDomains from './scenes/SettingsDomains';
import SettingsEmail from './scenes/SettingsEmail';
import SettingsGeneral from './scenes/SettingsGeneral/SettingsGeneral';
import SettingsHomepage from './scenes/SettingsHomepage/SettingsHomepage';
import SettingsIntegrations from './scenes/SettingsIntegrations';
import SettingsInvoices from './scenes/SettingsInvoices';
import SettingsMembers from './scenes/SettingsMembers';
import SettingsPayments from './scenes/SettingsPayments';
import SettingsStripe from './scenes/SettingsStripe';
import SettingsTax from './scenes/SettingsTax';
import SettingsApiKeys from './scenes/SettingsApiKeys/SettingsApiKeys';
import SettingsWebhooks from './scenes/SettingsWebhooks/SettingsWebhooks';
import SettingsPlan from './scenes/SettingsPlan';
import SettingsBilling from './scenes/SettingsBilling';
import SettingsCheckInStaff from './scenes/SettingsCheckInStaff';
import SettingsCheckoutProtection from './scenes/SettingsCheckoutProtection/SettingsCheckoutProtection';

const Settings = () => {
  return (
    <Switch>
      <Route path="/settings/general" component={SettingsGeneral} />
      <Route path="/settings/public-details" component={SettingsPublicDetails} />
      <Route path="/settings/members" component={SettingsMembers} />
      <Route path="/settings/payments" component={SettingsPayments} />
      <Route path="/settings/cart-abandonment" component={SettingsCartAbandonment} />
      <Route path="/settings/check-in-staff" component={SettingsCheckInStaff} />
      <Route path="/settings/checkout-protection" component={SettingsCheckoutProtection} />
      <Route path="/settings/invoices" component={SettingsInvoices} />
      <Route path="/settings/domains" component={SettingsDomains} />
      <Route path="/settings/homepage" component={SettingsHomepage} />
      <Route path="/settings/email" component={SettingsEmail} />
      <Route path="/settings/customer-portal" component={SettingsCustomerPortal} />
      <Route path="/settings/integrations" component={SettingsIntegrations} />
      <Route path="/settings/tax" component={SettingsTax} />
      <Route path="/settings/plan" component={SettingsPlan} />
      <Route path="/settings/billing" component={SettingsBilling} />
      <Route path="/settings/stripe" component={SettingsStripe} />
      <Route path="/settings/api" component={SettingsApiKeys} />
      <Route path="/settings/webhooks" component={SettingsWebhooks} />
      <Redirect exact from="/settings" to="/settings/general" />
    </Switch>
  );
};

export default Settings;
